import React from 'react'
import { Wrapper } from './style'
import { ModalButton } from 'src/components/Global/Button/Button'

import Select from 'react-select'
import { TargetTitle } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { TargetCheckbox } from 'src/components/Global/CheckBox/Checkbox'

const Logout = () => {
  const navigate = useNavigate()
  let location = useLocation()
  const handleLogout = () => {
    localStorage.removeItem('USER_DATA')
    setTimeout(function () {
      navigate('/accounts/login')
    }, 500)
  }
  function onDismiss() {
    navigate(-1)
  }

  return (
    <Wrapper>
      <h2>
        You are about to
        <br /> sign out
      </h2>
      <div className="top">
        <div className="center" onClick={handleLogout}>
          <ModalButton className="targets blue">Log out</ModalButton>
        </div>
      </div>
      <div className="top">
        <div onClick={onDismiss}>
          <ModalButton className="targets white">Cancel</ModalButton>
        </div>
      </div>
    </Wrapper>
  )
}
export { Logout }
